import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { AssetImage, Button, Tooltip } from 'ui';

const imagesByVariables = ['noPosts', 'noQuestionsNew', 'noQuestions', 'noTasks', 'noCourses'];

const NoItems = ({
  imageId,
  title,
  text,
  buttonText,
  buttonIcon,
  buttonOnClick,
  isButtonDisabled,
  buttonTooltip,
  secondButtonText,
  secondButtonIcon,
  secondButtonOnClick,
  size,
}) => {
  return (
    <div className={`no-items no-items--size-${size}`}>
      {!imagesByVariables.includes(imageId) && (
        <div className="no-items__item no-items__item--image">
          <AssetImage id={imageId} alt={text} />
        </div>
      )}

      {imagesByVariables.includes(imageId) && (
        <div
          className={clsx('no-items__empty-image', {
            'no-items__empty-image--no-posts': imageId === 'noPosts',
            'no-items__empty-image--no-questions-new': imageId === 'noQuestionsNew' || imageId === 'noTasks',
            'no-items__empty-image--no-questions': imageId === 'noQuestions',
            'no-items__empty-image--no-courses': imageId === 'noCourses',
          })}
        />
      )}

      <div className="no-items__item no-items__item--texts">
        <span className="no-items__item-title"> {title} </span>
        <span className="no-items__item-text"> {text} </span>
      </div>

      {buttonOnClick && (
        <div className="no-items__item">
          <Tooltip title={buttonTooltip} placement="top" hasArrow>
            {/* Un <button disabled> nativo no dispara eventos de hover/focus, así que el Tooltip
                no se abriría nunca; el <span> focuseable es quien recibe esos eventos y expone
                el motivo también a teclado/lector de pantalla. Solo lo hacemos focuseable si hay
                un motivo real que anunciar: si no, sería una parada de tabulación vacía. */}
            <span className="no-items__button-wrapper" tabIndex={isButtonDisabled && buttonTooltip ? 0 : undefined}>
              <Button size="sm" leftIcon={buttonIcon} text={buttonText} onClick={buttonOnClick} isFullWidth isDisabled={isButtonDisabled} />
            </span>
          </Tooltip>
        </div>
      )}
      {secondButtonOnClick && (
        <div className="no-items__item">
          <Button variant="primary-outline" size="sm" leftIcon={secondButtonIcon} text={secondButtonText} onClick={secondButtonOnClick} isFullWidth />
        </div>
      )}
    </div>
  );
};

NoItems.propTypes = {
  imageId: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  buttonText: PropTypes.string,
  buttonIcon: PropTypes.string,
  buttonOnClick: PropTypes.func,
  isButtonDisabled: PropTypes.bool,
  buttonTooltip: PropTypes.string,
  secondButtonText: PropTypes.string,
  secondButtonIcon: PropTypes.string,
  secondButtonOnClick: PropTypes.func,
  size: PropTypes.oneOf(['default', 'small', 'medium']),
};

NoItems.defaultProps = {
  buttonText: 'New',
  buttonIcon: 'add',
  isButtonDisabled: false,
  size: 'default',
};

export default NoItems;
